module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1042.7e062e8e.png";